import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useState, useRef } from "react";
import { Password } from "primereact/password";
import { useHistory } from "react-router";
import SecurityService from "../service/SecurityService";
import { useToast } from "../other/Toast";
import { Controller, useForm } from "react-hook-form";
import { classNames } from "primereact/utils";
import { Link } from "react-router-dom";
const logo = require("../../cdsc-Blue-Logo.png");

const LoginForm = () => {
  const toast = useToast();
  const history = useHistory();
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [errorMessage, setErrorMessage] = useState();

  const [rloading, setRloading] = useState(false);
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({});
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  return (
    <div
      className="compact-layout landing-page-card-center"
    >
      <div
        style={{
          maxWidth: 400,
          display: "flex",
          alignContent: "center",
          justifyContent: "center",
          placeContent: "center",
          backgroundColor: "#fff",
        }}
        className="p-col-12"
      >
        <div style={{ padding: 0 }} className="p-col-12">

          <div
            className="p-grid p-fluid"
            style={{ borderBottom: "1px solid #efefef" }}
          >
            <div
              style={{
                fontSize: 15,
                textAlign: "center",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignContent: 'center',
                alignItems: 'center',
                padding: 20,
              }}
              className="p-col-12 p-md-12"
            >
              <img src="./cdsc-Blue-Logo.png" style={{ height: 50 }} />{" "}
              <span
                style={{
                  paddingLeft: 10,
                  fontSize: 36,
                  textAlign: "center",
                  color: "#008080",
                  fontFamily: "'Spectral', serif",
                  transform: 'scale(1.25,1)'
                }}
              >
                CKYC {process.env.REACT_APP_API_URL} {process.env.API_URL}
              </span>
            </div>
            {errorMessage && <span
              style={{
                fontSize: 16,
                textAlign: "center",
                borderBottom: "1px solid #efefef",
                color: "#ff8080",
                padding: "0px 20px 10px 20px",
              }}
              className="p-col-12"
            >
              {errorMessage}
            </span>}
          </div>
          <div className="p-grid p-fluid" style={{ padding: 20 }}>
            <form
              className="p-col-12 p-md-12"
              style={{ padding: 0 }}
              onSubmit={handleSubmit((data) => {
                setRloading(true);
                SecurityService.auth(data.username, data.password)
                  .then(async (response) => {
                    sessionStorage.setItem(
                      "access_token",
                      response.data.jti
                    );
                    sessionStorage.setItem(
                      "refresh_token",
                      response.data.jti
                    );
                    sessionStorage.setItem("expires_in", eval(Date.now()));
                    await SecurityService.getUserInfo(history).catch((error) => {
                      toast.error("Unsuccessful", "Cannot get user info. Please login again");
                    });
                    setRloading(false);
                    // const user = parseJwt(response.data.jti);
                    // window.location.href = "/kyc/dashboard";
                    // if (user.passwordChanged) window.location.href = "/kyc/dashboard";
                    // else history.push("/change-password");

                  })
                  .catch((error) => {
                    setRloading(false);
                    if (!error || !error.response)
                      toast.error("Unsuccessful", "Unable to connect to the server");
                    else
                      switch (error.response.status) {
                        case 401:
                        case 403:
                        case 400:
                          setErrorMessage(error.response && error.response.data && (error.response.data.error_description === "Bad credentials" ? "Invalid Credentials" : error.response.data.error_description) || "Invalid Username or Password");
                          break;
                        case 500:
                          if (error.response.data.error_description)
                            toast.error("Unsuccessful", error.response.data.error_description);
                          else
                            toast.error("Unsuccessful", "Internal Server Error");
                          break;
                        case 503:
                          toast.error("Unsuccessful", "Service Temporarly not available");
                          break;
                        default:
                          toast.error("Unsuccessful", "Unexpected Error");
                      }
                  });
              })}
            >
              <div className="p-field p-col-12 p-md-12">
                <label className="p-col-12">
                  <i className="pi pi-user"></i> Username
                </label>
                <Controller
                  name="username"
                  control={control}
                  rules={{ required: "Username is required." }}
                  render={({ field, fieldState }) => (
                    <InputText
                      placeholder="Username"
                      id={field.name}
                      {...field}
                      keyfilter="alphanum"
                      onChangeCapture={() => setErrorMessage('')}
                      className={
                        "p-col-12 " +
                        classNames({ "p-invalid": fieldState.invalid })
                      }
                    />
                  )}
                />
                {getFormErrorMessage("username")}
              </div>
              <div className="p-field p-col-12 p-md-12">
                <label className="p-col-12">
                  <i className="pi pi-key"></i> Password
                </label>
                <Controller
                  name="password"
                  control={control}
                  rules={{ required: "Password is required." }}
                  render={({ field, fieldState }) => (
                    <Password
                      placeholder="Password"
                      toggleMask
                      style={{ paddingRight: 0, paddingLeft: 0, paddingTop: 0 }}
                      onChangeCapture={() => setErrorMessage('')}
                      id={field.name}
                      {...field} feedback={false}
                      className={
                        "p-col-12 " +
                        classNames({ "p-invalid": fieldState.invalid })
                      }
                    />
                  )}
                />
                {getFormErrorMessage("password")}
              </div>
              <div
                className="p-field p-col-12 p-md-12"
                style={{ paddingTop: 20 }}
              >
                <Button type="submit" className="p-col-12" label="Login" loading={rloading} iconPos="right">
                </Button>
              </div>
            </form>
            <div className="p-field p-col-12 p-md-12"
              style={{ textAlign: "center", paddingTop: 20 }} >
              Do not have an account?? <a style={{ textDecoration: 'none' }} href="/registration">Register
              </a>
            </div>
            <div
              className="p-field p-col-12 p-md-12"
              style={{ textAlign: "center", }}
            >
              <a style={{ textDecoration: 'none' }} href="/forgot-password">Forgot login details?</a>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

export default LoginForm;
